export const environment = {
  production: true,
  apiBaseUrl: 'https://prod.myfiveap.com/marketing',
  posthogKey: 'phc_oZdiWQgK9CeCQuga6b9qMrMnwb9ibPE5x79ocwUQ8ziY',
  posthogHost: 'https://us.i.posthog.com',
}; 

